const Auth = require('app/scripts/db/auth');
const Browser = require('@trello/browser');
const View = require('app/scripts/views/internal/view');
const log = require('app/scripts/debug/log');
const { track } = require('@trello/analytics');

const template = require('app/scripts/views/templates/footer_chrome');

class Footer extends View {
  static initClass() {
    this.prototype.className = 'embedded-board-footer';

    this.prototype.events = { 'click .js-logout': 'logout' };
  }

  render() {
    log('render', 'rendering footer');
    this.$el.html(
      template({
        url: this.options.url,
        shouldDisplayLogout: this.options.shouldDisplayLogout,
      }),
    );
    return this;
  }

  logout() {
    if (Auth.canLogIn()) {
      track('Log Out');
      if (Browser.isEmbeddedDocument()) {
        window.open(
          `/embed/logout.html`,
          '_blank',
          'width=200,height=100,noopener',
        );
      } else {
        Auth.logoutPost(this.options.getLogoutReturnUrl());
      }
    }
  }
}

Footer.initClass();
module.exports = Footer;
